<template>
  <v-stepper v-model="step" vertical class="elevation-0">
    <v-stepper-step :complete="step > 1" step="1" editable>
      <span slot v-html="stepOneText" />
    </v-stepper-step>
    <v-stepper-content step="1">
      <v-form
        ref="form"
        method="POST"
        @submit.prevent="!manualEntry  ? searchOrder() : submitManualRma()"
        v-model="valid"
      >
        <v-card color="primary" flat>
          <v-card-text class="pa-0">
            <v-tabs color="primary" dark icons-and-text>
              <v-tabs-slider color="secondary lighten-2"></v-tabs-slider>

              <v-tab href="#customer">
                Customer Information
                <v-icon>person</v-icon>
              </v-tab>

              <v-tab href="#order" v-if="!manualEntry">
                Order Information
                <v-icon>attach_money</v-icon>
              </v-tab>

              <v-tab-item value="customer" :disabled="!!order.name || !!order.team_id">
                <v-card class="mt-3" flat color="primary">
                  <v-card-text class="pa-0">
                    <v-layout row wrap>
                      <v-flex sm6 xs12>
                        <v-text-field
                          color="secondary"
                          label="Customer Name"
                          class="mx-2"
                          autofocus
                          :loading="isLoading"
                          v-model="customer.name"
                          :disabled="!!order.name || !!order.team_id"
                          :rules="[
                            v =>
                              isValid ||
                              `Did you want to ${ruleText} Customer\'s name?`
                          ]"
                          box
                        ></v-text-field>
                        <v-text-field
                          color="secondary"
                          label="Customer Email Address"
                          class="mx-2"
                          :loading="isLoading"
                          v-model="customer.email"
                          :disabled="!!order.name || !!order.team_id"
                          :rules="[
                            v =>
                              isValid ||
                              `Did you want to ${ruleText} Customer\'s email?`
                          ]"
                          box
                        ></v-text-field>

                        <v-text-field
                          color="secondary"
                          label="Customer Phone Number"
                          class="mx-2"
                          :loading="isLoading"
                          v-model="customer.phone"
                          :disabled="!!order.name || !!order.team_id"
                          :rules="[
                            v =>
                              isValid ||
                              `Did you want to ${ruleText} Customer\'s phone number?`
                          ]"
                          box
                        ></v-text-field>
                        <v-combobox
                          color="secondary"
                          label="State"
                          class="mx-2"
                          v-if="manualEntry"
                          v-model="customer.state_id"
                          :loading="isLoading"
                          :items="stateSelects"
                          :rules="[
                            v =>
                              isValid ||
                              `Did you want to ${ruleText} Customer\'s state?`
                          ]"
                          item-text="name"
                          :item-value="stateSelected"
                          :return-object="false"
                          box
                        />
                      </v-flex>
                      <v-flex sm6 xs12>
                        <v-text-field
                          color="secondary"
                          label="Address"
                          class="mx-2"
                          :loading="isLoading"
                          v-model="customer.street"
                          :disabled="!!order.name || !!order.team_id"
                          :rules="[
                            v =>
                              isValid ||
                              `Did you want to ${ruleText} Customer\'s address?`
                          ]"
                          box
                        ></v-text-field>

                        <v-text-field
                          color="secondary"
                          label="Address 2"
                          class="mx-2"
                          v-if="manualEntry"
                          :loading="isLoading"
                          v-model="customer.street2"
                          :disabled="!!order.name || !!order.team_id"
                          :rules="[
                            v =>
                              isValid ||
                              `Did you want to ${ruleText} Customer\'s Street 2?`
                          ]"
                          box
                        ></v-text-field>

                        <v-text-field
                          color="secondary"
                          label="City"
                          class="mx-2"
                          :loading="isLoading"
                          v-model="customer.city"
                          :disabled="!!order.name || !!order.team_id"
                          :rules="[
                            v =>
                              isValid ||
                              `Did you want to ${ruleText} Customer\'s city?`
                          ]"
                          box
                        ></v-text-field>

                        <v-text-field
                          color="secondary"
                          label="Postal Code"
                          class="mx-2"
                          :loading="isLoading"
                          v-model="customer.zip"
                          :disabled="!!order.name || !!order.team_id"
                          :rules="[
                            v =>
                              isValid ||
                              `Did you want to ${ruleText} Customer\'s postal code?`
                          ]"
                          box
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item value="order">
                <v-card flat color="primary" class="mt-3">
                  <v-card-text class="pa-0">
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                        <v-text-field
                          ref="orderNumber"
                          color="secondary"
                          label="Order Number"
                          class="mx-2"
                          v-model="order.name"
                          :loading="isLoading"
                          :disabled="
                            !!customer.name ||
                              !!customer.email ||
                              !!customer.phone ||
                              !!customer.street ||
                              !!customer.city ||
                              !!customer.zip
                          "
                          :rules="[
                            v =>
                              isValid ||
                              'Did you want to search by Order Number?'
                          ]"
                          box
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-combobox
                          v-model="order.team_id"
                          :items="channels"
                          item-text="name"
                          item-value="name"
                          label="Sales Channel"
                          color="secondary"
                          class="mx-2"
                          :loading="isLoading"
                          :disabled="
                            !!customer.name ||
                              !!customer.email ||
                              !!customer.phone ||
                              !!customer.street ||
                              !!customer.city ||
                              !!customer.zip
                          "
                          :rules="[
                            v =>
                              isValid ||
                              'Did you want to search by Sales Channel?'
                          ]"
                          :return-object="false"
                          cache-items
                          required
                          box
                        ></v-combobox>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                        <v-layout>
                          <v-flex>
                            <v-checkbox
                              v-model="order.state.draft"
                              label="Quotation"
                              color="secondary lighten-2"
                              class="mt-0 pl-3"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                          <v-flex>
                            <v-checkbox
                              v-model="order.state.sale"
                              label="Sales Order"
                              color="secondary lighten-2"
                              class="mt-0"
                              hide-details
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
            <v-layout row wrap>
              <v-flex></v-flex>
            </v-layout>
          </v-card-text>

          <v-btn type="submit" color="secondary lighten-2" :loading="isLoading" flat>
            {{
            !manualEntry ? 'Search' : 'Submit' }}
          </v-btn>
          <v-btn @click="resetSearchForm" flat>reset</v-btn>
          <v-spacer />
          <!-- <v-radio-group color="secondary lighten-2" v-model="manualEntry" row class="ml-4">
            <v-radio color="secondary lighten-2" label="Odoo" :value="false" />
            <v-radio color="secondary lighten-2" label="Manual Entry" :value="true" />
          </v-radio-group>-->
          <v-radio-group color="secondary lighten-2" v-model="searchType" row class="ml-4">
            <v-radio
              v-if="!manualEntry"
              color="secondary lighten-2"
              label="Value Contains"
              value="ilike"
            />
            <v-radio v-if="!manualEntry" color="secondary lighten-2" label="Exact Match" value="=" />
          </v-radio-group>
        </v-card>
      </v-form>
    </v-stepper-content>

    <v-stepper-step :complete="step > 2" step="2" :editable="1 < orders.length">
      Select an order
      <small>
        This step is only required when more than one order matches your search
        criteria. This step allows you to select from a list of orders:
      </small>
    </v-stepper-step>
    <v-stepper-content step="2">
      <v-card color="primary">
        <v-card-text class="pa-0">
          <v-flex xs12>
            <v-alert class="pt-a" :value="10 < orderLength" type="warning" color="secondary">
              <strong>{{ orderLength }}</strong> orders found matching your
              search criteria. If the order you are looking for is not in this
              list, please
              <strong
                @click="resetSearchForm"
                style="cursor:pointer;text-decoration:underline;color:primary;"
              >retry</strong>
              with more specific search criteria to reduce the number of
              matches.
            </v-alert>
          </v-flex>
          <v-list v-if="orders.length > 0" two-line class="pa-0">
            <template v-for="(result, index) in orders">
              <OrderListItem
                :key="index"
                :order="result"
                v-on:order-selected="selectedOrder = $event"
              />
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-stepper-content>

    <v-stepper-step :complete="step > 3" step="3" :editable="!!selectedOrder">
      Review the order
      <small>Review and select the products which need to be RMA'd:</small>
    </v-stepper-step>
    <v-stepper-content step="3">
      <v-card v-if="selectedOrder && !this.manualEntry" color="white" class="primary--text">
        <v-card-title>
          <h1>{{ selectedOrder.name }}</h1>
          <v-spacer></v-spacer>
          <h2>{{ "sale" === selectedOrder.state ? "Sales Order" : "Quotation" }}</h2>
          
        </v-card-title>
        <v-card-title primary-title  v-if="totalMatches > 0">
          
          <td :style="{backgroundColor: 'yellow'}">
            <h4><strong>An RMA has already been created for this order!</strong></h4>
          </td>
        </v-card-title>
        <v-card-text>
          <v-divider light></v-divider>
          <v-layout row wrap>
            <v-flex v-if="selectedOrder && partner" md6 sm6 xs12>
              <div v-if="partner.name" class="secondary--text">{{ partner.name }}</div>
              <div v-if="partner.street" class="secondary--text">{{ partner.street }}</div>
              <div class="secondary--text" v-if="partner.street2">{{ partner.street2 }}</div>
              <div
                v-if="partner.city || partner.state_id || partner.zip"
                class="secondary--text"
              >{{ partner.city }}, {{ partner.state_id[1] }} {{ partner.zip }}</div>
              <div v-if="partner.country_id" class="secondary--text">{{ partner.country_id[1] }}</div>
            </v-flex>

            <v-flex md6 sm6 xs12>
              <v-layout row wrap>
                <v-flex sm3 xs5>Sales Channel:</v-flex>
                <v-flex v-if="selectedOrder.team_id" class="secondary--text">
                  {{
                  selectedOrder.team_id[1]
                  }}
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex sm3 xs5>Date Ordered:</v-flex>
                <v-flex
                  v-if="selectedOrder.date_order"
                  class="secondary--text"
                >{{ selectedOrder.date_order }}</v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex sm3 xs5>Shipping Method:</v-flex>
                <v-flex
                  v-if="selectedOrder.carrier_id"
                  class="secondary--text"
                >{{ selectedOrder.carrier_id[1] }}</v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex sm3 xs5>Channel Advisor ID:</v-flex>
                <v-flex
                  v-if="selectedOrder.x_order_id"
                  class="secondary--text"
                >{{ selectedOrder.x_order_id }}</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider v-if="selectedOrder.carrier_id" light></v-divider>
          <h2 v-if="selectedOrder.carrier_id" class="mt-3">Pickings:</h2>
          <ul id="pickings" v-if="selectedOrder.carrier_id" class="ma-0 pa-0 mt-3">
            <li v-for="picking in pickings" :key="picking.id" class="secondary--text lighten-4">
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <h4>{{ picking.name }}</h4>
                </v-flex>
                <v-flex xs12 sm3>
                  <h4>{{ picking.state.toUpperCase() }}</h4>
                </v-flex>
                <v-flex xs12 sm6>
                  <a
                    :href="
                      getUrl(picking.carrier_id, picking.carrier_tracking_ref)
                    "
                    target="new"
                    style="display:block"
                  >{{ picking.carrier_tracking_ref }}</a>
                </v-flex>
              </v-layout>
            </li>
          </ul>
          <v-divider class="mt-3" light></v-divider>
          <v-layout class="mt-3" row wrap>
            <v-flex v-if="0 < selectedProducts.length" xs12 md8>
              <h2>
                {{ selectedProducts.length }} of {{ lines.length }} Product(s)
                Selected for RMA:
              </h2>
            </v-flex>

            <v-flex v-else xs12 md8>
              <h2>{{ lines.length }} Product(s):</h2>
            </v-flex>

            <v-flex xs12 md4>
              <v-text-field
                v-if="5 < lines.length"
                v-model="searchStr"
                prepend-inner-icon="search"
                placeholder="Search"
                single-line
                hide-details
                autofocus
                clearable
                light
                solo
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-data-table
            color="white"
            v-if="0 < lines.length"
            v-model="selectedProducts"
            :headers="headers"
            :items="lines"
            :loading="isLoading"
            :pagination.sync="pagination"
            select-all
            :search="searchStr"
            item-key="name"
            light
          >
            <template v-slot:headers="props">
              <tr>
                <th>
                  <v-checkbox
                    color="secondary"
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.stop="toggleAll"
                  ></v-checkbox>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    header.class,
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : ''
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr
                :active="props.selected"
                @click="disableProductSelect(props.item) ? '' : props.selected = !props.selected"
                :style="{color: disableProductSelect(props.item) ? '#D3D3D3' : ''}"
              >
                <td>
                  <v-tooltip bottom>
                    <v-checkbox
                      :disabled="disableProductSelect(props.item)"
                      color="secondary"
                      :input-value="props.selected"
                      primary
                      slot="activator"
                      hide-details
                    ></v-checkbox>
                    <span>{{ disableProductSelect(props.item) ? 'This Product is Past the Allowed Date for an RMA' : 'RMA This Product'}}</span>
                  </v-tooltip>
                </td>
                <td>{{ props.item.product_id[1] }}</td>
                <td class="text-xs-center">{{ props.item.price_unit | currency }}</td>
                <td class="text-xs-center">{{ props.item.product_qty }}</td>
                <td class="text-xs-center">
                  {{
                  (props.item.price_unit * props.item.product_qty) | currency
                  }}
                </td>
              </tr>
            </template>
            <template v-slot:footer v-if="showWarrantyWarning">
              <td :style="{backgroundColor: 'yellow'}" colspan="1">
                <v-icon>warning</v-icon>
              </td>
              <td :style="{backgroundColor: 'yellow'}" :colspan="headers.length">
                <strong>Warning! Some product(s) surpass the warranty date!</strong>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="0 < lines.length"
            @click="step = 4"
            color="secondary"
            :loading="isLoading"
            :disabled="0 === selectedProducts.length"
            flat
          >
            RMA
            {{
            1 === selectedProducts.length ? "this product" : "these products"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-else color="white" class="primary--text">
        <v-card-title>
          <v-layout row>
            <h1 :style="{width: '50%'}">
              <v-text-field
                color="secondary"
                label="Enter the order number"
                class="mt-3"
                v-model="manual.order.name"
                :rules="[
              v =>
                isValid ||
                `You must enter an order number!`
            ]"
                solo
                light
              />
            </h1>
            <span :style="{width: '50%'}">
              <v-menu v-model="manualDatePicker" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    solo
                    color="secondary"
                    class="mt-3 ml-2"
                    label="Enter the Order Date"
                    v-model="manual.order.date_order"
                    readonly
                    v-on="on"
                    light
                  />
                </template>
                <v-date-picker v-model="manual.order.date_order" color="secondary" no-title />
              </v-menu>
            </span>
            <v-combobox
              v-model="manual.order.team_id"
              :items="channels"
              item-text="name"
              :item-value="teamSelected"
              class="mt-3 ml-2"
              label="Sales Channel"
              color="secondary"
              :loading="isLoading"
              :return-object="false"
              required
              light
              solo
            ></v-combobox>
          </v-layout>
          <v-spacer></v-spacer>
          <h2>Manual Order</h2>
        </v-card-title>
        <v-card-text>
          <v-divider light></v-divider>
          <v-layout row wrap>
            <v-flex v-if="customer.name" md6 sm6 xs12>
              <div v-if="customer.name" class="secondary--text">{{ customer.name }}</div>
              <div v-if="customer.street" class="secondary--text">{{ customer.street }}</div>
              <div class="secondary--text" v-if="customer.street2">{{ customer.street2 }}</div>
              <div
                v-if="customer.city || customer.state_id || customer.zip"
                class="secondary--text"
              >{{ customer.city }}, {{customer.state_id ? customer.state_id.name : ""}} {{ customer.zip || ""}}</div>
              <div class="secondary--text">{{customer.country || "United States"}}</div>
            </v-flex>

            <v-flex md6 sm6 xs12>
              <v-layout row wrap>
                <v-flex sm3 xs5>Customer Phone:</v-flex>
                <v-flex v-if="customer.phone" class="secondary--text">
                  {{
                  customer.phone
                  }}
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex sm3 xs5>Customer Email:</v-flex>
                <v-flex v-if="customer.email" class="secondary--text">
                  {{
                  customer.email
                  }}
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider light></v-divider>
          <v-layout class="mt-3" row wrap>
            <v-flex xs12 md8>
              <h2>{{ manual.products.length }} Product(s):</h2>
            </v-flex>
            <v-flex xs12>
              <v-divider class="mt-3" light></v-divider>
            </v-flex>
            <v-flex xs12 v-if="manual.products.length > 0" class="mt-3">
              <span v-for="(product, index) in manual.products" :key="index">
                <v-layout row>
                  <ProductSearch class="mx-3" @product-selected="productSearch" :index="index" />
                  <v-text-field
                    v-model="manual.products[index].product_qty"
                    type="number"
                    label="Quantity"
                    solo
                    light
                    color="secondary"
                    class="mx-3"
                  />
                  <v-text-field
                    v-model="manual.products[index].price_unit"
                    type="number"
                    label="Price"
                    solo
                    light
                    color="secondary"
                    class="mx-3"
                  />
                  <v-btn color="error" icon class="mt-2" @click="manual.products.splice(index, 1)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-layout>
              </span>
            </v-flex>
            <v-flex xs12 md8 :style="{textAlign: 'center', margin: 'auto'}">
              <v-btn
                color="success"
                icon
                large
                @click="manual.products.push({name: '', product_qty: '', id: ''})"
              >
                <v-icon large>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-btn
              v-if="0 < manual.products.length"
              @click="handleManualRma()"
              color="secondary"
              flat
            >
              RMA
              {{
              1 === manual.products.length ? "this product" : "these products"
              }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-stepper-content>

    <v-stepper-step step="4" :editable="1 < selectedProducts.length">
      Finalize RMA
      <small>Select reasons for RMA for each impacted product:</small>
    </v-stepper-step>
    <v-stepper-content step="4">
      <SubmitRMA
        :selected-products="!manualEntry ? selectedProducts : manual.products"
        :order="selectedOrder"
        :customer="scrubPartner()"
        :manualEntry="manualEntry"
      />
    </v-stepper-content>
  </v-stepper>
</template>

<script>
import OrderListItem from "@/components/rma/OrderListItem";
import SubmitRMA from "@/components/rma/SubmitRMA";
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import ProductSearch from "@/components/app/ProductSearch";
import Common from "@/mixins/Common";

export default {
  data() {
    return {
      step: 1,
      valid: true,
      right: null,
      partner: null,
      selectedOrder: null,
      searchStr: "",
      searchType: "=",
      selectedProducts: [],

      order: {
        name: null,
        team_id: null,
        state: {
          draft: true,
          sale: true
        }
      },

      customer: {
        id: null,
        phone: null,
        name: null,
        street: null,
        street2: null,
        city: null,
        state_id: null,
        zip: null,
        email: null
      },

      pagination: {
        sortBy: "name"
      },

      headers: [
        { text: "Product Name", value: "name", class: "first", align: "left" },
        { text: "Price", value: "Price", class: "first", align: "center" },
        { text: "Quantity", value: "Quantity" },
        { text: "Total", value: "Total", class: "first", align: "center" }
      ],

      manualEntry: false,

      manual: {
        order: {
          name: null,
          date_order: null
        },
        products: []
      },

      manualDatePicker: false,
      productOwners: [],
      permissionOverrideWarranty: [],
      showWarrantyWarning: false
    };
  },

  mixins: [Common],

  components: {
    OrderListItem,
    SubmitRMA,
    ProductSearch
  },

  computed: {
    ...mapGetters({
      orders: "order/getOrders",
      orderLength: "order/getLength",
      orderLimit: "order/getLimit",
      orderOffset: "order/getOffset",
      isLoading: "app/isLoading",
      token: "app/getToken",
      rma: "rma/getRma",
      rmas: "rma/getRmas",
      pickings: "picking/getPickings",
      lines: "saleOrderLine/getSaleOrderLines",
      partners: "partner/getPartners",
      partnerUrl: "partner/getOnePartnerUrl",
      channels: "salesTeam/getTeams",
      newPartner: "partner/getNewPartner",
      countrySelects: "countriesAndStates/getCountries",
      stateSelects: "countriesAndStates/getStates",
      user: "app/getUser",
      permissions: "settings/getPermissions",
      totalMatches: "rma/getTotalMatches",
    }),

    isValid() {
      return (
        !!this.order.name ||
        !!this.order.team_id ||
        !!this.customer.name ||
        !!this.customer.email ||
        !!this.customer.phone ||
        !!this.customer.street ||
        !!this.customer.zip ||
        !!this.customer.city
      );
    },

    stepOneText() {
      return !this.manualEntry
        ? `Search for an Odoo order <br />
        <small> Search for the order by Order or customer information. </small>`
        : `Create a Manual RMA <br />
        <small> Enter Details about the customer to create an RMA. </small>`;
    },

    ruleText() {
      return !this.manualEntry ? "search by" : "add the";
    },

    manualID() {
      let date = new Date();
      let year = date
        .getFullYear()
        .toString()
        .substr(2, 2);
      let month = ("0" + date.getHours()).substr(-2);
      let day = ("0" + date.getMinutes()).substr(-2);
      let julian = ("00" + this.julianDate()).substr(-3);
      return parseInt(`${year}${julian}${month}${day}`);
    }
  },

  methods: {
    ...mapActions({
      showSnackbar: "app/setSnackbar",
      setLoading: "app/setLoading",
      fetchSaleOrderLines: "saleOrderLine/search",
      resetOrders: "order/resetOrders",
      getPickings: "picking/search",
      search: "rma/search",
      load: "rma/load",
      clear: "rma/clearRma",
      fetchMoveLine: "stockMoveLine/search"
    }),

    scrubPartner() {
      if (this.partner) {
        return {
          id: this.partner.id,
          name: this.partner.name,
          street: this.partner.street,
          street2: this.partner.street2,
          city: this.partner.city,
          state: this.partner.state_id[1],
          country: this.partner.country_id[1],
          zip: this.partner.zip,
          email: this.partner.email,
          phone: this.partner.phone
        };
      }
    },

    getUrl(id, ref) {
      if (id[1].toLowerCase().includes("ups"))
        return `https://www.ups.com/track?loc=en_US&tracknum=${ref}&requester=WT/`;
      if (id[1].toLowerCase().includes("dhl"))
        return `http://webtrack.dhlglobalmail.com/?trackingnumber=${ref}`;

      return `https://tools.usps.com/go/TrackConfirmAction_input?qtc_tLabels1=${ref}`;
    },

    searchOrder() {
      if (this.isValid && this.$refs.form.validate()) {
        this.selectedOrder = null;
        this.resetOrders();

        let conditions = [];
        const isOrderSearch = this.order.name || this.order.team_id;
        const model =
          this.order.name || this.order.team_id ? this.order : this.customer;

        for (let condition in model) {
          if (model[condition] && "state" !== condition) {
            conditions.push({
              field: condition,
              operator: this.searchType,
              value: model[condition]
            });
          }
        }

        if (isOrderSearch) {
          let states = [];
          if (this.order.state.sale) {
            states.push("sale");
          }

          if (this.order.state.draft) {
            states.push("draft");
          }

          conditions.push({
            field: "state",
            operator: "in",
            value: states
          });
        }

        conditions.push({
          field: "team_id",
          operator: "not in",
          value: [1, 34, 21]
        });

        this.$store.dispatch(
          `${isOrderSearch ? "order" : "partner"}/search`,
          conditions,
          {
            root: true
          }
        );
        this.showWarrantyWarning = false;
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: "At least one field is required to submit a search",
          color: "red"
        });
      }
    },

    resetSearchForm() {
      this.$refs.form.reset();
      this.resetOrders();
      this.selectedOrder = null;
      this.partner = null;
      this.searchType = "=";
      this.step = 1;
      this.order.state.draft = true;
      this.order.state.sale = true;
    },

    async selectOrder(order) {
      this.selectedOrder = order;

      if (this.selectedOrder) {
        try {
          this.setLoading(true);
          await this.load(
            {
              rowsPerPage: 1,
              page:1,
              sortBy: 'name',
              direction: 'desc',
              search: this.selectedOrder.name,
              states: []
            }
          )
          await this.fetchSaleOrderLines(this.selectedOrder.id);
          if (this.selectedOrder.team_id[0] != 36) {
           this.modifyDiscountLines();
          }
          await this.getPickings([
            {
              field: "sale_id",
              operator: "=",
              value: this.selectedOrder.id
            }
          ]);

          if (this.selectedOrder.partner_id) {
            
            const { data } = await Axios({
              method: "GET",
              url: `${this.partnerUrl}/${this.selectedOrder.partner_id[0]}`,
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            });

            this.partner = data.bindle;
          }
        } catch (error) {
          this.showSnackbar({
            text: error.message,
            color: "red"
          });
        } finally {
          this.setLoading(false);
          this.step = 3;
        }
      }
    },

    toggleAll() {
      if (this.selectedProducts.length) this.selectedProducts = [];
      else
        this.selectedProducts = this.lines.filter(item => {
          if (!this.disableProductSelect(item)) {
            return item;
          }
        });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    modifyDiscountLines() {
      let hasDiscount = this.lines.filter(line => line.product_id[0] == 82630);
      if (hasDiscount.length) {
        let totalAmount = this.lines.reduce((acc, line) => {
          if (line.product_id[0] != 82630) {
            return acc + parseFloat(line.price_unit) * parseFloat(line.product_qty);
          } else return acc;
        }, 0);
        this.lines.forEach(line => {
          if (line.product_id[0] != 82630) {
            let discount = parseFloat(line.price_unit) / totalAmount * hasDiscount[0].price_unit;
            line.price_unit = parseFloat(line.price_unit) + discount;
          }
        });
      }
    },

    previousPage() {
      this.$store.dispatch("order/paginateSearch", {
        conditions: [
          {
            field: "name",
            operator: "ilike",
            value: "114-77"
          }
        ],
        limit: 10,
        offset: 10
      });
    },

    nextPage() {
      this.$store.dispatch("order/paginateSearch", {
        conditions: [
          {
            field: "name",
            operator: "ilike",
            value: "114-77"
          }
        ],
        limit: 10,
        offset: 10
      });
    },

    disableProductSelect(item) {
      let disabled = false;

      let salesChannel = this.selectedOrder.team_id;
      let sku = item.product_id[1].toLowerCase()[1];
      let createDate = new Date(
        this.selectedOrder.date_order.replace(" ", "T")
      );
      let thirtyDays = new Date(
        this.selectedOrder.date_order.replace(" ", "T")
      );
      thirtyDays.setDate(thirtyDays.getDate() + 30);
      let ninetyDays = new Date(
        this.selectedOrder.date_order.replace(" ", "T")
      );
      ninetyDays.setDate(ninetyDays.getDate() + 90);
      let today = new Date();

      switch (sku) {
        case "n":
        case "s":
        case "p":
          if (today >= thirtyDays) {
            disabled = true;
            this.showWarrantyWarning = true;
          } else disabled = false;
          break;
        case "r":
        case "c":
          if (today >= ninetyDays) {
            disabled = true;
            this.showWarrantyWarning = true;
          } else disabled = false;
          break;
        default:
          disabled = false;
          break;
      }

      if (this.permissionOverrideWarranty.includes(this.user.displayName)) {
        disabled = false;
      }
      if (salesChannel[0] === 12) disabled = false;
      if (this.user._groups.includes("Admins")) {
        disabled = false;
      }

      return disabled;
    },

    async submitManualRma() {
      try {
        let args = {
          name: this.customer.name || this.throwErrorMsg("No Name Entered"),
          street:
            this.customer.street || this.throwErrorMsg("No Street Entered."),
          street2: this.customer.street2 || "      ",
          city: this.customer.city || this.throwErrorMsg("No City Entered."),
          state_id: this.customer.state_id
            ? this.customer.state_id.id
              ? this.customer.state_id.id
              : this.throwErrorMsg("No State Selected.")
            : this.throwErrorMsg("No State Selected."),
          country_id: this.customer.country || 233,
          zip: this.customer.zip || this.throwErrorMsg("No Zip Code."),
          email: this.customer.email || "",
          phone: this.customer.phone || "9726462550"
        };

        if (!this.partner) {
          this.partner = await this.$store.dispatch("partner/create", {
            kwargs: args
          })[0];
        }

        this.step = 3;
      } catch (error) {
        this.$store.dispatch("app/setSnackbar", {
          color: "red",
          text: error
        });
      }
    },

    async handleManualRma() {
      try {
        if (!this.manual.order.team_id)
          this.throwErrorMsg("No sales team selected.");
        else if (!this.manual.order.name)
          this.throwErrorMsg("No order number entered.");
        else if (!this.manual.order.date_order)
          this.throwErrorMsg("No order date selected.");
        else {
          this.manual.products.forEach(product => {
            if (!product.name) this.throwErrorMsg("No product entered.");
            else if (!product.product_qty)
              this.throwErrorMsg("No quantity entered for product.");
            else if (!product.price_unit)
              this.throwErrorMsg("No price entered for product.");
          });
          await this.step++;
          let order = this.manual.order;
          order.id = this.manualID;
          this.selectedOrder = order;
          this.selectedProducts = this.manual.products;
        }
      } catch (error) {
        this.$store.dispatch("app/setSnackbar", {
          color: "red",
          text: error
        });
      }
    },

    throwErrorMsg(msg) {
      throw new Error(msg);
    },

    productSearch(e) {
      this.manual.products[e.index].name = e.display_name;
      this.manual.products[e.index].id = e.id;
      return e;
    },

    async loadStates() {
      await this.$store.dispatch("countriesAndStates/loadStates", 233);
    },

    stateSelected(e) {
      let { name, id, code } = e;
      return { name, id, code };
    },

    teamSelected(e) {
      let { name, id } = e;
      return { name, id };
    },

    async computeProductOwner(line) {
      this.productOwners = await this.fetchMoveLine([
        {
          field: "id",
          operator: "in",
          value: line
        }
      ]);
      this.productOwners = this.productOwners.map(product => {
        return {
          product: product.product_id[0],
          owner: product.owner_id[1]
        };
      });
    },

    async setPermissions() {
      await this.$store.dispatch("settings/getPermissions");
      this.permissions.map(user => {
        user.permissions.forEach(permission => {
          if (permission.permissionID === 1) {
            if (permission.permission)
              this.permissionOverrideWarranty.push(user.displayName);
          }
        });
      });
    }
  },

  mounted() {
    this.$store.dispatch("salesTeam/search", []);
    this.$store.dispatch("rma/getCategories", []);
    this.setPermissions();
  },

  watch: {
    rma(rma) {
      if (rma) {
        this.$emit("rma-created", rma);
        this.clear();
      }
    },

    orders(newVal) {
      if (1 === newVal.length) {
        this.setLoading(false);
        this.selectOrder(newVal.pop());
      } else if (1 < newVal.length) {
        this.setLoading(false);
        this.step = 2;
      }
    },

    selectedOrder(newOrder) {
      this.selectOrder(newOrder);
    },

    partners(partners) {
      let ids = [];

      partners.forEach(customer => {
        ids = [...ids, ...customer.sale_order_ids];
      });

      this.$store.dispatch("order/search", [
        {
          field: "id",
          operator: "in",
          value: ids
        },
        {
          field: "state",
          operator: "=",
          value: "sale"
        }
      ]);
    },

    newPartner(val) {
      if (val) {
        this.partner = val[0];
      }
    },

    manualEntry(val) {
      if (val) {
        this.loadStates();
      }
    },

    pickings(val) {
      if (val) {
        val.forEach(picking => {
          if (picking.state === "done") {
            this.computeProductOwner(picking.move_line_ids);
          }
        });
      }
    },

    selectedProducts: {
      handler(val) {
        if (val.length > 0) {
          val.map(product => {
            this.productOwners.forEach(owner => {
              if (product.product_id[0] === owner.product)
                product.owner = owner.owner;
            });
            return product;
          });
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
}

.first {
  text-align: left;
}

#or_lbl {
  text-align: center;
  margin-bottom: 20px;
}

#pickings:nth-child(even) {
  background-color: #f5f5f5;
}

div.v-datatable__actions {
  background: white !important;
}
>>> .theme--dark.v-picker__body {
  background: #333c42 !important;
}
</style>
